// Section 4: A1 Criteria Checklist. Thin
// wrapper around the reusable <CriteriaChecklist lane="A1" /> component.

import { Card } from "@/design-system/components/ui";
import { CriteriaChecklist } from "../../CriteriaChecklist";
import type { CriteriaLane } from "@/api/dealFlow/types";

interface CriteriaChecklistSectionProps {
  dealId: string;
  /** Defaults to A1 because Section 4 of the Underwriting tab is the A1
   *  surface. */
  lane?: CriteriaLane;
  /** When true, the row write affordances are hidden. */
  readOnly?: boolean;
}

export function CriteriaChecklistSection({
  dealId,
  lane = "A1",
  readOnly = false,
}: CriteriaChecklistSectionProps) {
  return (
    <Card>
      <header className="mb-space-3">
        <h3 className="font-display text-h4 text-onyx m-0">
          Section 4 — Criteria Checklist ({lane})
        </h3>
        <p className="text-caption text-gray-mid m-0">
          Walk every catalog item, certify or decline with rationale, and
          escalate anything outside your authority.
        </p>
      </header>
      <CriteriaChecklist dealId={dealId} lane={lane} readOnly={readOnly} />
    </Card>
  );
}
